webpackJsonp([269067597282543],{

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"], ["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var UpdateLayout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[1];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[4] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	var Prismic = __webpack_require__(36);
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Updates = function (_React$Component) {
	  _inherits(Updates, _React$Component);
	
	  function Updates(props) {
	    _classCallCheck(this, Updates);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.changeRegion = function (event) {
	      _this.setState({ region: event.target.value }, function () {
	        _this.getUpdates(false);
	      });
	    };
	
	    _this.changeCampaign = function (event) {
	      _this.setState({ campaign: event.target.value }, function () {
	        _this.getUpdates(false);
	      });
	    };
	
	    _this.changeInstitution = function (event) {
	      _this.setState({ institution: event.target.value }, function () {
	        _this.getUpdates(false);
	      });
	    };
	
	    _this.getUpdates = function (add) {
	      var predicates = [Prismic.Predicates.at("document.type", "update"), Prismic.Predicates.not("my.update.uid", "hidden-update")];
	      if (_this.state.region !== "") {
	        predicates.push(Prismic.Predicates.at("my.update.region", _this.state.region));
	      }
	      if (_this.state.institution !== "") {
	        predicates.push(Prismic.Predicates.at("my.update.institution", _this.state.institution));
	      }
	      var page = 1;
	      if (add) {
	        page = _this.state.updatePage + 1;
	      }
	      // if campaign is null, do a standard query, else..
	      if (_this.state.campaign === "") {
	        Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	          return api.query(predicates, {
	            lang: _this.props.data.page.lang,
	            fetchLinks: "region.uid",
	            page: page,
	            pageSize: _this.state.updateLimit,
	            orderings: "[my.update.publish_date desc]"
	          });
	        }).then(function (response) {
	          if (!add) {
	            _this.setState({ updates: response.results, updatePage: 1 });
	          } else {
	            var updatesCurrent = JSON.parse(JSON.stringify(_this.state.updates));
	            var updates = updatesCurrent.concat(response.results);
	            _this.setState({ updates: updates, updatePage: page });
	          }
	        });
	      } else {
	        var predicates1 = JSON.parse(JSON.stringify(predicates));
	        var predicates2 = JSON.parse(JSON.stringify(predicates));
	        var predicates3 = JSON.parse(JSON.stringify(predicates));
	        var predicates4 = JSON.parse(JSON.stringify(predicates));
	        if (_this.state.campaign !== "") {
	          predicates1.push(Prismic.Predicates.at("my.update.campaign", _this.state.campaign));
	          predicates2.push(Prismic.Predicates.at("my.update.campaign2", _this.state.campaign));
	          predicates3.push(Prismic.Predicates.at("my.update.campaign3", _this.state.campaign));
	          predicates4.push(Prismic.Predicates.at("my.update.campaign4", _this.state.campaign));
	        }
	        var results = [];
	        // query four times to get them all
	        Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	          return api.query(predicates1, {
	            lang: _this.props.data.page.lang,
	            fetchLinks: "region.uid",
	            page: page,
	            pageSize: _this.state.updateLimit,
	            orderings: "[my.update.publish_date desc]"
	          });
	        }).then(function (response) {
	          results = [].concat(results, response.results);
	          Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	            return api.query(predicates2, {
	              lang: _this.props.data.page.lang,
	              fetchLinks: "region.uid",
	              page: page,
	              pageSize: _this.state.updateLimit,
	              orderings: "[my.update.publish_date desc]"
	            });
	          }).then(function (response2) {
	            results = [].concat(results, response2.results);
	            Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	              return api.query(predicates3, {
	                lang: _this.props.data.page.lang,
	                fetchLinks: "region.uid",
	                page: page,
	                pageSize: _this.state.updateLimit,
	                orderings: "[my.update.publish_date desc]"
	              });
	            }).then(function (response3) {
	              results = [].concat(results, response3.results);
	              Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	                return api.query(predicates4, {
	                  lang: _this.props.data.page.lang,
	                  fetchLinks: "region.uid",
	                  page: page,
	                  pageSize: _this.state.updateLimit,
	                  orderings: "[my.update.publish_date desc]"
	                });
	              }).then(function (response4) {
	                results = [].concat(results, response4.results).sort(function (a, b) {
	                  return a.data.publish_date > b.data.publish_date ? -1 : 1;
	                });
	                if (!add) {
	                  _this.setState({ updates: results, updatePage: 1 });
	                } else {
	                  var updatesCurrent = JSON.parse(JSON.stringify(_this.state.updates));
	                  var updates = updatesCurrent.concat(results);
	                  _this.setState({ updates: updates, updatePage: page });
	                }
	              });
	            });
	          });
	        });
	      }
	    };
	
	    _this.setFiltersFromPath = function () {
	      if (_this.props.location.search.indexOf("campaign") !== -1) {
	        _this.setState({ campaign: _this.props.location.search.split("=")[1] }, function () {
	          _this.getUpdates(false);
	        });
	      }
	      if (_this.props.location.search.indexOf("institution") !== -1) {
	        _this.setState({ institution: _this.props.location.search.split("=")[1] }, function () {
	          _this.getUpdates(false);
	        });
	      }
	      if (_this.props.location.search.indexOf("region") !== -1) {
	        _this.setState({ region: _this.props.location.search.split("=")[1] }, function () {
	          _this.getUpdates(false);
	        });
	      }
	      if (_this.props.location.search.indexOf("region") === -1 && _this.props.location.search.indexOf("institution") === -1 && _this.props.location.search.indexOf("campaign") === -1) {
	        _this.getUpdates(false);
	      }
	    };
	
	    _this.state = {
	      updates: [],
	      updateLimit: 12,
	      updatePage: 1,
	      campaign: "",
	      region: "",
	      institution: ""
	    };
	    return _this;
	  }
	
	  Updates.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	    this.setFiltersFromPath();
	  };
	
	  Updates.prototype.render = function render() {
	    var _this2 = this;
	
	    var json = undefined;
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    if (this.props.data.regions) {
	      this.props.data.regions.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.uid },
	          json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	          json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          json.data.body1[0] && _react2.default.createElement(
	            _components.PageSidebar,
	            null,
	            json.data.body1.map(function (callout, index) {
	              return _react2.default.createElement(_components.CalloutCard, {
	                key: "callout" + index,
	                callout: callout.primary,
	                lang: json.lang
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            json.data.body && _react2.default.createElement(_components.Article, {
	              dangerouslySetInnerHTML: {
	                __html: _prismicDom.RichText.asHtml(json.data.body, linkResolver)
	              }
	            }),
	            _react2.default.createElement(
	              _rebass.Box,
	              { my: 6 },
	              _react2.default.createElement(
	                _components.FilterBar,
	                { lang: json.lang },
	                _react2.default.createElement(
	                  _components.Select,
	                  {
	                    onChange: this.changeRegion,
	                    value: this.state.region,
	                    "aria-label": "Filter by Region"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    json.lang === "en-us" ? "All Regions" : json.lang === "es-mx" ? "Todas las regiones" : "كل المناطق"
	                  ),
	                  this.props.data.regions.edges.map(function (region, index) {
	                    return _react2.default.createElement("option", {
	                      children: region.node.data.title[0].text,
	                      value: region.node.prismicId,
	                      key: "region" + index
	                    });
	                  })
	                ),
	                _react2.default.createElement(
	                  _components.Select,
	                  {
	                    onChange: this.changeCampaign,
	                    value: this.state.campaign,
	                    "aria-label": "Filter by Campaign"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    json.lang === "en-us" ? "All Campaigns" : json.lang === "es-mx" ? "Todas las campañas" : "كل المناطق"
	                  ),
	                  this.props.data.campaigns.edges.map(function (campaign, index) {
	                    return _react2.default.createElement("option", {
	                      children: campaign.node.data.title[0].text,
	                      value: campaign.node.prismicId,
	                      key: "campaign" + index
	                    });
	                  })
	                ),
	                _react2.default.createElement(
	                  _components.Select,
	                  {
	                    onChange: this.changeInstitution,
	                    value: this.state.institution,
	                    "aria-label": "Filter by Institution"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    json.lang === "en-us" ? "All Institutions" : json.lang === "es-mx" ? "Todas las instituciones" : "جميع المؤسسات"
	                  ),
	                  this.props.data.institutions.edges.map(function (institution, index) {
	                    return _react2.default.createElement("option", {
	                      children: institution.node.data.title[0].text,
	                      value: institution.node.prismicId,
	                      key: "institution" + index
	                    });
	                  })
	                )
	              )
	            ),
	            this.state.updates && _react2.default.createElement(
	              UpdateLayout,
	              null,
	              this.state.updates.map(function (update, index) {
	                return _react2.default.createElement(_components.UpdateCard, {
	                  key: "update" + index,
	                  object: update,
	                  institutions: _this2.props.data.institutions.edges,
	                  campaigns: _this2.props.data.campaigns.edges
	                });
	              })
	            ),
	            this.state.updates.length !== this.state.updateLimit * this.state.updatePage && _react2.default.createElement(
	              _rebass.Flex,
	              { width: "100%", justify: "center" },
	              _react2.default.createElement(
	                _rebass.Box,
	                { pt: 6, style: { textAlign: "center" } },
	                _react2.default.createElement(_components.Text, {
	                  children: json.lang === "en-us" ? "Didn't find what you are looking for?" : json.lang === "es-mx" ? "¿No encontró lo que estaba buscando?" : "لم تجد ما تبحث عنه؟",
	                  mb: 3
	                }),
	                _react2.default.createElement(_components.PrimaryButton, {
	                  children: json.lang === "en-us" ? "Get in touch" : json.lang === "es-mx" ? "Póngase en contacto" : "اتصل بنا",
	                  is: _gatsbyLink2.default,
	                  to: "/" + json.lang + "/contact"
	                })
	              )
	            ),
	            this.state.updates.length === this.state.updateLimit * this.state.updatePage && _react2.default.createElement(
	              _rebass.Flex,
	              { width: "100%", justify: "center" },
	              _react2.default.createElement(
	                _rebass.Box,
	                { pt: 6 },
	                _react2.default.createElement(_components.PrimaryButton, {
	                  children: json.lang === "en-us" ? "View More" : json.lang === "es-mx" ? "Ver más" : "عرض المزيد",
	                  onClick: function onClick() {
	                    _this2.getUpdates(true);
	                  }
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Updates;
	}(_react2.default.Component);
	
	Updates.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Updates;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-updates-js-e2143b9f74d8415b1655.js